module.exports = __webpack_public_path__ + "media/images/facebook-f1b5a3160f371f2e5621db6cdc43e2c9.png";